module.exports = __webpack_public_path__ + "media/安慰.793f0797.mp3";